import { axios } from '@Root/API'

export const getFieldsForContact = contactId => {
	return axios.get(`contact/${contactId}/additional-field`)
}
